import { useState } from "react";
import { useAppDispatch } from "hooks";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import { CircularProgress, FormControlLabel, Switch } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { simulateGiftGalorePurchase } from "redux/slices";
import { useSimulatePurchasesMutation } from "redux/apis/clubGiftsGalore";

interface CGGProps {
	version: "v1" | "v2";
}

const SetClubGiftsGalorePurchaseDialog = ({ version }: CGGProps) => {
	const dispatch = useAppDispatch();
	const [open, setOpen] = useState<boolean>(false);
	const [fieldValue, setFieldValue] = useState<number>(1);
	const [resetTracker, setResetTracker] = useState<boolean>(false);
	const [excludeCurrentUser, setExcludeCurrentUser] = useState<boolean>(true);
	const [simulatePurchases, { isLoading }] = useSimulatePurchasesMutation();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFieldValue(e.target.valueAsNumber);
	};

	const handleSetPurchases = async () => {
		if (fieldValue < 0) {
			return;
		}
		version === "v1"
			? await dispatch(simulateGiftGalorePurchase(fieldValue))
			: await simulatePurchases({
					body: {
						count: fieldValue,
						excludeCurrentUser: excludeCurrentUser,
						resetTracker: resetTracker
					}
			  }).unwrap();
		setOpen(false);
	};

	return (
		<div>
			<Button variant="outlined" onClick={handleClickOpen}>
				{version === "v1" ? "Submit" : "Simulate Purchases"}
			</Button>
			<Dialog open={open} onClose={handleClose}>
				<DialogTitle>Submit</DialogTitle>
				<DialogContent>
					<TextField
						onChange={onChange}
						autoFocus
						margin="dense"
						id="name"
						defaultValue={fieldValue}
						label="Simulate Purchases"
						type="number"
						fullWidth
						variant="standard"
					/>
					{version === "v2" && (
						<>
							<div>
								<FormControlLabel
									control={
										<Switch
											title="Exclude current user"
											checked={excludeCurrentUser}
											onChange={(e) => setExcludeCurrentUser(e.target.checked)}
										/>
									}
									label="Exclude current user"
									labelPlacement="start"
								/>
							</div>
							<div>
								<FormControlLabel
									control={
										<Switch
											title="Reset tracker"
											checked={resetTracker}
											onChange={(e) => setResetTracker(e.target.checked)}
										/>
									}
									label="Reset tracker"
									labelPlacement="start"
								/>
							</div>
						</>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose}>Cancel</Button>
					<Button onClick={handleSetPurchases}>
						{isLoading ? <CircularProgress size={"0.875rem"} /> : "Submit"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SetClubGiftsGalorePurchaseDialog;
